export default {
  hero: {
    title: '문의하기',
    subtitle: '함께 디지털 미래를 만들어 갑시다'
  },

  serviceRegions: {
    title: '7대 서비스 지역',
    subtitle: '아시아태평양 전역의 전문 서비스 팀이 현지화된 지원을 제공합니다',
    officeAddress: '서비스 센터',
    phone: '전화번호',
    email: '이메일 주소',
    workingHours: '운영 시간',
    officeHoursNote: '응답 일정은 지역과 서비스 수준에 따라 조정될 수 있습니다.',
    noOfficeInfo: '해당 지역의 서비스 센터 정보는 확인 중입니다. 우선 이메일로 문의해 주세요.',
    regions: {
      china: {
        name: '중국 본토',
        description: '중국 지역은 상하이, 베이징, 선전을 중심으로 지역 간 IT 제공과 현지 수행을 지원합니다.',
        offices: [
          {
            title: '상하이 서비스 센터',
            addressLines: [
              'Room 1003-1, Guangming Real Estate Building',
              'No. 199 Xizang North Road',
              'Jing\'an District, Shanghai, China'
            ],
            coordinates: { lat: 31.2411, lng: 121.4754 }
          },
          {
            title: '베이징 서비스 센터',
            addressLines: [
              'No. 18, Jingjia Road',
              'Yanqi Town, Huairou District',
              'Beijing, China'
            ],
            coordinates: { lat: 40.4018, lng: 116.6766 }
          },
          {
            title: '선전 서비스 센터',
            addressLines: [
              'Unit 55, Room 1407, Building B, Phase 1',
              'Tian\'an Innovation Technology Plaza',
              'No. 4 Tairan Road, Futian District, Shenzhen, China'
            ],
            coordinates: { lat: 22.5412, lng: 114.0539 }
          }
        ],
        workingHours: '월요일-금요일 9:00-18:00'
      },
      hongkong: {
        name: '중국 홍콩',
        description: '홍콩 서비스 센터는 국제 비즈니스 협업과 현지 서비스 제공을 지원하며 국경 간 IT 및 비즈니스 요구를 대응합니다.',
        offices: [
          {
            title: '홍콩 서비스 센터',
            addressLines: [
              'Room A, 1/F., Arthur Commercial Building,',
              '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
            ],
            coordinates: { lat: 22.3070, lng: 114.1714 }
          }
        ],
        workingHours: '월요일-금요일 9:30-18:30'
      },
      taiwan: {
        name: '타이베이',
        description: '대만 지역 서비스 범위는 확보되어 있으며, 서비스 센터 세부 정보는 고객 확인을 기다리고 있습니다.',
        offices: [],
        workingHours: '월요일-금요일 9:00-18:00'
      },
      singapore: {
        name: '싱가포르',
        description: '싱가포르는 동남아시아 지역 허브로서 지역 제공 협업과 비즈니스 커뮤니케이션을 지원합니다.',
        offices: [
          {
            title: '싱가포르 서비스 센터',
            addressLines: [
              '10 ANSON ROAD',
              '#27-18',
              'INTERNATIONAL PLAZA',
              'SINGAPORE (079903)'
            ],
            coordinates: { lat: 1.2752, lng: 103.8453 }
          }
        ],
        workingHours: '월요일-금요일 9:00-18:00'
      },
      japan: {
        name: '일본',
        description: '일본 서비스 센터는 현지 고객과 다국적 프로젝트를 지원하며 일본어 환경의 현지 서비스 제공이 가능합니다.',
        offices: [
          {
            title: '일본 서비스 센터',
            addressLines: [
              '208, 2-9-17 HIGASHITABATA, KITA-KU,',
              'TOKYO 114-0013, JAPAN'
            ],
            coordinates: { lat: 35.7412, lng: 139.7600 }
          }
        ],
        workingHours: '월요일-금요일 9:00-18:00'
      },
      korea: {
        name: '서울',
        description: '한국 지역 서비스 범위는 확보되어 있으며, 서비스 센터 세부 정보는 고객 확인을 기다리고 있습니다.',
        offices: [],
        workingHours: '월요일-금요일 9:00-18:00'
      }
    }
  },

  instantCommunication: {
    title: '즉시 커뮤니케이션',
    subtitle: '다채널 빠른 연락, 전문 팀이 항상 대기하고 있습니다',
    liveChat: {
      title: '실시간 채팅',
      description: '업무 시간 내 즉시 응답',
      button: '대화 시작',
      hours: '월-금 9:00-18:00'
    },
    wechat: {
      title: '기업 WeChat',
      description: 'QR을 스캔해 기업 WeChat 추가',
      qrcode: 'QR 코드 스캔하여 추가',
      qrcodeAlt: '기업 WeChat 연락용 QR 코드'
    },
    whatsapp: {
      title: 'WhatsApp',
      description: '국제 비즈니스용 빠른 연락',
      button: '메시지 보내기'
    }
  },

  formSection: {
    consultation: {
      tab: '비즈니스 문의',
      title: '비즈니스 문의',
      description: '문의 양식을 작성해 주시면 전문 팀이 24시간 이내에 연락드려 맞춤형 IT 솔루션과 프로젝트 제안을 안내합니다.',
      benefits: {
        analysis: '무료 요구 분석 및 솔루션 제안',
        demo: '전문가 1:1 대응',
        response: '24시간 이내 신속 응답',
        privacy: '개인정보 보호'
      }
    },
    partnership: {
      tab: '비즈니스 파트너십',
      title: '비즈니스 파트너십',
      description: '채널 파트너, 기술 제휴사, 솔루션 통합사가 함께 협력하여 시장을 확장하고 상호 성장을 이루는 논의를 환영합니다.',
      benefits: {
        channel: '채널 파트너 프로그램',
        tech: '기술 제휴 및 통합',
        solution: '공동 솔루션 개발',
        support: '종합 지원 및 교육'
      }
    },
    inquiryType: {
      label: '문의 유형',
      partnershipLabel: '협력 유형',
      placeholder: '유형을 선택해 주세요',
      consultation: {
        solution: '솔루션 상담',
        product: '제품 기능 문의',
        pricing: '가격 및 견적',
        demo: '제품 데모',
        support: '기술 지원'
      },
      partnership: {
        channel: '채널 협력',
        technology: '기술 제휴',
        integration: '솔루션 통합',
        consulting: '컨설팅 협력',
        other: '기타 협력'
      }
    },
    region: {
      label: '서비스 지역',
      placeholder: '서비스 지역을 선택해 주세요',
      china: '중국 본토',
      hongkong: '중국 홍콩',
      taiwan: '중국 대만',
      singapore: '싱가포르',
      japan: '일본',
      korea: '대한민국'
    }
  },

  info: {
    title: '연락처 정보',
    address: {
      title: '서비스 센터 주소',
      content: '중국 상하이시 징안구 시짱베이로 199호 광밍부동산빌딩 1003-1실'
    },
    phone: {
      title: '전화번호',
      content: '+86 21 8765 4321'
    },
    email: {
      title: '이메일 주소'
    },
    hours: {
      title: '운영 시간',
      content: '월요일 - 금요일 9:00-18:00'
    }
  },

  social: {
    title: '팔로우하기'
  },

  form: {
    title: '메시지 보내기',
    companyName: '회사명',
    companyNamePlaceholder: '회사명을 입력해 주세요',
    contactName: '담당자명',
    contactNamePlaceholder: '이름을 입력해 주세요',
    position: '직책',
    positionPlaceholder: '직책을 입력해 주세요',
    email: '이메일 주소',
    emailPlaceholder: '이메일 주소를 입력해 주세요',
    phone: '전화번호',
    phonePlaceholder: '전화번호를 입력해 주세요',
    industry: '산업',
    industryPlaceholder: '산업을 선택해 주세요',
    industries: {
      technology: '기술',
      finance: '금융',
      healthcare: '헬스케어',
      education: '교육',
      manufacturing: '제조',
      retail: '리테일',
      other: '기타'
    },
    companySize: '회사 규모',
    companySizePlaceholder: '회사 규모를 선택해 주세요',
    employees: '명',
    interestedServices: '관심 서비스',
    serviceOptions: {
      ticketSystem: '스마트 티켓 시스템',
      aiSolutions: 'AI 솔루션',
      dataAnalytics: '데이터 분석',
      consulting: 'IT 컨설팅'
    },
    budget: '프로젝트 예산',
    budgetPlaceholder: '예산 구간을 선택해 주세요',
    budgetOptions: {
      under50k: '50K 미만',
      range50k100k: '50K - 100K',
      range100k500k: '100K - 500K',
      range500k1m: '500K - 1M',
      over1m: '1M 이상'
    },
    message: '프로젝트 설명',
    messagePlaceholder: '프로젝트 요구사항과 기대 효과를 자세히 작성해 주세요',
    submit: '문의 제출',
    submitting: '제출 중'
  },

  success: {
    title: '제출 완료',
    message: '문의가 정상적으로 접수되었습니다. 24시간 이내에 연락드리겠습니다.',
    close: '확인'
  },

  regions: {
    title: '서비스 지역',
    selectRegion: '지역 선택',
    allRegions: '전체 지역'
  }
}
